// Overlay

$(function() {
  'use strict';

  var $buttons = $('.js-overlay-button');

  $buttons.each(function(index, button) {

    var $button     = $(button),
        $overlay    = $('#' + $button.attr('aria-controls')),
        $close      = $overlay.find('.js-overlay-close'),
        $container  = $overlay.find('.js-overlay-container'),
        $body       = $('body'),
        $window     = $(window),
        scrollTop   = 0,
        closeCenter = {
          'x': $close.outerWidth() / 2,
          'y': $close.outerHeight() / 2
        };

    $button.on('click', function(event) {
      event.preventDefault();

      if($button.attr('href')) {
        $container.html('<div class="c-content l-overlay__content"><figure class="c-content__figure c-figure"><div class="c-figure__embed"><iframe src="' + $button.attr('href') + '?autoplay=1" width="420" height="315" allowfullscreen></iframe></div></figure></div>');
      }

      var state = true;

      $button.attr('aria-expanded', state);
      $overlay.attr('aria-hidden', !state);

      $overlay.attr('tabIndex', !state ? '-1' : '');

      scrollTop = $window.scrollTop();
      $body.addClass('no-scroll').css('top', -scrollTop + 'px');
    });

    $close.on('click', function(event) {
      event.preventDefault();
      event.stopPropagation();

      var state = false;

      $button.attr('aria-expanded', state);
      $overlay.attr('aria-hidden', !state);

      $overlay.attr('tabIndex', !state ? '-1' : '');
      $container.html('');
      $body.removeClass('no-scroll').css('top', '');
      $window.scrollTop(scrollTop);
    });

    $overlay.on('mousemove', function(event) {

      closeCenter = {
        'x': $close.outerWidth() / 2,
        'y': $close.outerHeight() / 2
      };

      if(!Modernizr.touchevents) {

        var $target = $(event.target),
            is_link = event.target.hasAttribute('href'),
            has_link = $target.parents('[href]').length > 0;

        if(is_link || has_link) {
          $close.css({
            display: 'none'
          });
        } else {
          $close.css({
            left: event.pageX - $overlay.offset().left - closeCenter.x,
            top: event.pageY - $overlay.offset().top - closeCenter.y,
            bottom: 'auto',
            display: ''
          });
        }
      }
    });

    $overlay.on('click', function(event) {
      if(!Modernizr.touchevents) {
        var $target = $(event.target),
            is_link = event.target.hasAttribute('href'),
            has_link = $target.parents('[href]').length > 0;

        if(!is_link && !has_link) {
          $close.trigger('click');
        }
      }
    });

    $overlay.hover(function(event) {
      if(!Modernizr.touchevents) {
        $close.addClass('is-moving');
      }
    }, function(event) {
      if(!Modernizr.touchevents) {
        $close.removeClass('is-moving');
      }
    });
  });

});
